import type { IPost } from "../../../../types/models/post.models.types";
import { useGetHttp } from "../../http.hook";

export interface IPostResponse {
  posts: Array<IPost>;
}

export function useSearchPostsAdminHttp() {
  return useGetHttp<IPostResponse>({
    path: "/admin/posts/search",
  });
}
